import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'

@Component({
	selector: 'app-list-csv-export-button',
	standalone: true,
	imports: [MatIconModule, MatTooltipModule],
	templateUrl: './list-csv-export-button.component.html',
	styleUrl: './list-csv-export-button.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListCsvExportButtonComponent {
	readonly disabled = input(false)
	readonly label = input('Descargar CSV')
	readonly tooltip = input('Descargar CSV')

	readonly downloadClicked = output<void>()
}
